import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

const PlaybackHeader = ({ deviceName = "", onToggleFullscreen }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: "14px",
        py: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid rgba(0,0,0,0.08)",
      }}
    >
      <Typography sx={{ fontSize: 13, color: theme.palette.primary.dark, fontWeight: 600 }}>
        {deviceName}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <IconButton size="small" onClick={onToggleFullscreen} sx={{ color: "#555", p: 0.25 }}>
          <FullscreenIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
    </Box>
  );
};

PlaybackHeader.propTypes = {
  deviceName: PropTypes.string,
  onToggleFullscreen: PropTypes.func.isRequired,
};

export default PlaybackHeader;
